// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component } from '@angular/core';
import { HeaderService } from '../../../header.service';
import { BehaviorSubject } from 'rxjs';
import { ALL_ORGS_ID } from '../../../../types/group';

@Component({
    selector: 'app-endpoint-protections',
    templateUrl: './endpoint-protections.component.html',
    styleUrls: ['./endpoint-protections.component.scss'],
    standalone: false
})
export class EndpointProtectionsComponent {
  selectedOrgId$: BehaviorSubject<string> = new BehaviorSubject<string>(ALL_ORGS_ID);

  constructor(private headerService: HeaderService) {
     this.selectedOrgId$ = this.headerService.orgSelectedChanged;
  }
}
